import ActionTypes from '../../actionTypes';
/**
 * Action creator for updating the selected criteria
 */
var updateSelectedCriteria = function (criteria) { return ({
    type: ActionTypes.UPDATE_GLOBAL_DATA_SELECTED_CRITERIA,
    payload: criteria,
}); };
export default updateSelectedCriteria;
